import React from "react";
import AuditDetails from "../Settings/Audits/pages/AuditDetails";

const AuditorAuditDetails = () => {
  return <AuditDetails isAuditorView={true} />;
};

export default AuditorAuditDetails;
